import { render, staticRenderFns } from "./PlaceholderEventBanner.vue?vue&type=template&id=1b2503f2&"
import script from "./PlaceholderEventBanner.vue?vue&type=script&lang=js&"
export * from "./PlaceholderEventBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports